module.exports = __webpack_public_path__ + "img/logo-dark@2x.78f69ba9.png";